import React from "react";
import * as Redux from 'react-redux';
import {Link} from 'react-router-dom';
import $ from 'jquery';

import * as pageActions from './../actions/pageActions';
import userImage from './../images/user-image.svg';
import logo from './../images/logo.svg';
import ScrollToTopOnMount from './ScrollToTopOnMount';
import Component from './Component';
import * as configHelper from './../helpers/configHelper';
import * as displayHelper from './../helpers/displayHelper';

export class TopMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {...this.defaultState};
	}

	initialize(props, state) {
		var newState = super.initialize(props, state);
		this.setState({...state, ...newState});
	}

	initialized() {
		this.initializeMenu();
		super.initialized();
	}

	initializeMenu() {
		if (!this.isMenuInitialized) {
			$('.ui.right.dropdown.item.user').dropdown();
			$('.ui.dropdown.item.launch.icon').dropdown();
			this.isMenuInitialized = true;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (!super.shouldComponentUpdate(nextProps, nextState))
			return false;

		if (this.state.lastUpdate !== nextState.lastUpdate)
			return true;

		if (this.props.config.user.updated_at !== nextProps.config.user.updated_at)
			return true;

		if (this.props.config.isLoaded !== nextProps.config.isLoaded)
			return true;

		return false;
	}

	render() {
      const {config, dispatch} = this.props;
        
		var userImageElement = <div className="default-user-image"><img src={userImage} alt=""/></div>;
		if(config.isLoaded && config.user.avatar && config.user.avatar.length > 0){
			userImageElement = <div className={`user-image`} style={{backgroundImage: `url(${config.user.avatar})`}}></div>
		}

		var menuOptions = [];

		if (config.isLoaded) {
			menuOptions.push(<a key="userprofile" className="item" href={ process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "users/" + config.user.id + "/edit" }>User Profile</a>);
			menuOptions.push(<a key="defaultcities" className="item" href={ process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "profile/cities"}>Default Cities</a>);
			menuOptions.push(<div key="divider" className="divider"></div>);
		    
         if (configHelper.canManage(config)) {
            menuOptions.push(<a key="accountsettings" className="item" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "accounts/" + config.account.id }>Account Settings</a>);
            if (config.account.is_premium)
               menuOptions.push(<a key="accountmarketing" className="item" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "marketing/" + config.account.id }>Marketing & Syndication</a>);
            menuOptions.push(<a key="accountbilling" className="item billing-item" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "billing"}>Account Billing</a>);
				menuOptions.push(<a key="manageusers" className="item" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "users"}>Manage Users</a>);
	    	}

			menuOptions.push(<a key="managetags" className="item" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "tags"}>Manage Tags</a>);

         if (!config.account.syndicate.is_share_all && config.account.is_premium)
            menuOptions.push(<a key="websitewidgets" className="item website-widgets-item" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "website"}>Website Solutions</a>);
   				
			if (config.isLoaded && config.user.role_admin && config.account.is_premium && !config.account.syndicate.is_share_all)	      	
				menuOptions.push(<a key="weeklybackup" className="item weekly-back" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "backup"}>Weekly Backup</a>);
			
			if (configHelper.canManage(config))
				menuOptions.push(<div key="divier2" className="divider"></div>);

			menuOptions.push(<a key="logout" className="item logout" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "auth/logout"}>Logout</a>);
		} else {
			menuOptions.push(<a key="logout" className="item logout" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "login"}>Login</a>);
      }
		
		const links = displayHelper.menuLinks(config, dispatch);
		
		return (
			<div className="ui borderless menu top-menu">
            <input type="hidden" id="selectAgent" name="selectAgent" value={config.isLoaded && config.user ? config.user.id : ""} />

				<ScrollToTopOnMount />
				<div className="ui container">
					{
						links.length > 0
							? <div className="ui dropdown item launch icon">
								<i className="menu-icon"></i>
								<div className="mobile-menu menu">
                                    <div className="logo">
                                        <img src={logo} alt="Logo" />
                                    </div>
							    	{ links } 
							    </div>
							</div>
					      	: ""
					}
					<div className="right menu">
						<div className="item help">
							{ configHelper.isAccountActive(config)
                                ? <a href="javascript:showClassicWidget();">
                                    <i className="fa fa-question-circle-o"></i>
                                </a>
                                : <span>&nbsp;</span>
							}
						</div>
						<div className="ui right dropdown item user">
							{userImageElement}
						    <div className="menu">
						    	{menuOptions}
						    </div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Redux.connect(
	(state) => {
		return state;
	}
)(TopMenu);



// WEBPACK FOOTER //
// ./src/components/TopMenu.js